import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const handleCategoryClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="categories" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-accent-500 uppercase tracking-wider mb-3">
            Popular Categories
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            Browse the <span className="text-primary-500">Best ACBuy Spreadsheet</span> Categories
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Explore all 14 curated <strong>acbuy spreadsheet</strong> categories with verified product links — from shoes and hoodies to accessories and perfumes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {categories.map((cat, idx) => {
            const isDark = idx === 0;
            return (
              <button
                key={cat.name}
                onClick={() => handleCategoryClick(cat.url)}
                className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-[1.02] text-left ${
                  isDark ? 'bg-foreground-900' : 'bg-background-100'
                }`}
              >
                {isDark ? (
                  <div className="p-6 h-full min-h-[200px] flex flex-col justify-between">
                    <div className="w-10 h-10 rounded-full bg-background-50/20 flex items-center justify-center mb-4">
                      <span className="text-background-50 text-sm font-bold">{cat.name.charAt(0)}</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-background-50">{cat.name}</h3>
                      <p className="text-xs text-background-50/50 mt-1">Verified Links →</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="h-40 overflow-hidden">
                      <img
                        src={cat.imageUrl}
                        alt={`ACBuy Spreadsheet ${cat.name} category`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="text-sm font-semibold text-foreground-900">{cat.name}</h3>
                      <p className="text-xs text-foreground-500 mt-1">Browse Products →</p>
                    </div>
                  </>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}